import { styled, Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import React from 'react';

import { useTopAreaStore } from '../stores/TopAreaStore';
import { ExpandableContent } from './ExpandableContent';

const StyledContent = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  margin: theme.spacing(4, 'auto', 5),
  maxWidth: 'calc(100% - 20px)',
  position: 'relative',
  width: '100%',
  [theme.breakpoints.up(600)]: {
    maxWidth: '600px',
  },
  [theme.breakpoints.up(768)]: {
    margin: theme.spacing(5, 'auto', 12),
  },
}));

const StyledHeader = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(20),
  fontWeight: theme.typography.fontWeightBold,
  textAlign: 'center',
  [theme.breakpoints.up(768)]: {
    marginTop: theme.spacing(9),
  },
}));

export const Content: FC = () => {
  const { contentDescription, contentHeadline } = useTopAreaStore();
  const { getTestId } = useTestId();

  if (!contentHeadline && !contentDescription) {
    return null;
  }

  return (
    <StyledContent data-testid={getTestId('content')}>
      {contentHeadline ? <StyledHeader>{contentHeadline}</StyledHeader> : null}
      <ExpandableContent>{contentDescription}</ExpandableContent>
    </StyledContent>
  );
};
